/* eslint-disable no-redeclare */
import { z } from 'zod';

export const HtmlText = z.string();

export type HtmlText = z.infer<typeof HtmlText>;
